import React from 'react';

const box = (color) => ({ background: `${color}14`, border: `1px solid ${color}55`, borderRadius: 10, padding: 14 });
const th = { padding: 8 };

const Stat = ({ value, label, hint, color, testid }) => (
  <div style={box(color)} data-testid={testid}>
    <div style={{ fontSize: 24, fontWeight: 700, color }}>{value}</div>
    <div style={{ fontSize: 13, color: '#e6e9ef' }}>{label}</div>
    {hint && <div style={{ fontSize: 12, color: '#b6bfce', marginTop: 4 }}>{hint}</div>}
  </div>
);

const daysColor = (d) => (d <= 1 ? '#ef4444' : d <= 7 ? '#f59e0b' : '#e6e9ef');

export const CountdownReport = ({ data }) => (
  <div style={{ marginBottom: 24 }} data-testid="countdown-report">
    <h3 style={{ color: '#f1f4f9', margin: '8px 0 12px', fontSize: 16 }}>⏳ 14-day deletion countdown</h3>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: 12 }}>
      <Stat testid="countdown-started" value={data.started} label="Entered countdown" hint="Starter mailboxes that hit 20/20" color="#4db8ff" />
      <Stat testid="countdown-active" value={data.active_count} label="Counting down now" color="#f59e0b" />
      <Stat testid="countdown-paid" value={data.paid} label="Paid $14.99" hint={`$${data.paid_revenue} saved from deletion`} color="#22c55e" />
      <Stat testid="countdown-released" value={data.released} label="Deleted (released)" color="#ef4444" />
      <Stat testid="countdown-rate" value={data.paid_rate_pct === null ? '—' : `${data.paid_rate_pct}%`} label="Pay rate" hint={data.unlocked ? `${data.unlocked} unlocked by admin/reset` : 'paid ÷ (paid + deleted)'} color="#a78bfa" />
    </div>

    {data.active.length > 0 ? (
      <div className="table-wrap" style={{ overflowX: 'auto', marginTop: 14 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', color: '#e6e9ef', fontSize: 13 }} data-testid="countdown-active-table">
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '1px solid #2a3142', color: '#f1f4f9' }}>
              <th style={th}>Mailbox</th><th style={th}>User</th><th style={th}>Days left</th>
              <th style={th}>Deletes on</th><th style={th}>Held emails</th><th style={th}>Reminders</th>
            </tr>
          </thead>
          <tbody>
            {data.active.map((a) => (
              <tr key={a.email_address} style={{ borderBottom: '1px solid #1e2430' }} data-testid={`countdown-row-${a.email_address.split('@')[0]}`}>
                <td style={th}>{a.email_address}</td>
                <td style={th}>{a.name || '—'} <span style={{ color: '#7d8799' }}>({a.chat_id})</span></td>
                <td style={{ ...th, fontWeight: 700, color: daysColor(a.days_left) }}>{a.days_left}</td>
                <td style={{ ...th, color: '#b6bfce' }}>{new Date(a.deadline).toLocaleDateString()}</td>
                <td style={th}>{a.held_emails}</td>
                <td style={th}>{a.reminders_sent}/3</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p style={{ color: '#b6bfce', fontSize: 13, marginTop: 12 }} data-testid="countdown-empty">No mailboxes are counting down right now.</p>
    )}
  </div>
);

export default CountdownReport;
